import {
  Component,
  OnInit,
  inject,
  DestroyRef,
  HostListener,
  ElementRef,
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { WINDOW } from 'src/app/utils/window-token'
import { ModalService, FilePreview } from 'src/app/services/modal.service'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnInit, AfterViewChecked {
  private el = inject(ElementRef)
  private cdr = inject(ChangeDetectorRef)
  private sanitizer = inject(DomSanitizer)
  private previousFocus: HTMLElement | null = null
  private needsFocus = false
  private modalService = inject(ModalService)
  private destroyRef = inject(DestroyRef)
  private window = inject(WINDOW)

  filePreview?: FilePreview
  exibir: boolean = false
  trustedUrl!: SafeUrl
  isPreviewable: boolean = true
  iframeHeight: number = 400

  ngOnInit(): void {
    this.iframeHeight = this.window.innerHeight - 200
    this.subscribeToModal()
  }

  subscribeToModal() {
    this.modalService.modalEventsArquivo.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(filePreview => {
      this.filePreview = filePreview

      const fileExtension = filePreview.file.name.split('.').pop()?.toLowerCase()
      this.isPreviewable = fileExtension !== 'zip'

      if (this.isPreviewable) {
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(filePreview.file))
      } else {
        this.trustedUrl = ''
      }

      this.toggle()
      this.cdr.markForCheck()
    })
  }

  ngAfterViewChecked(): void {
    if (this.needsFocus && this.exibir) {
      this.needsFocus = false
      const first = this.el.nativeElement.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      first?.focus()
    }
  }

  @HostListener('keydown', ['$event'])
  onTab(event: KeyboardEvent): void {
    if (event.key !== 'Tab' || !this.exibir) return
    const focusable = this.el.nativeElement.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    if (!focusable.length) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.exibir) this.cancelar()
  }

  toggle(): void {
    if (!this.exibir) {
      this.previousFocus = document.activeElement as HTMLElement
      this.needsFocus = true
    } else {
      this.previousFocus?.focus()
    }
    this.exibir = !this.exibir
  }

  cancelar(): void {
    this.toggle()
    this.modalService.enviar(false)
  }

  enviar(): void {
    this.toggle()
    this.modalService.enviar(true)
  }
}
